<template>
  <body class="pt-12">
    <div v-if="loadGimbal">
      <img
        height="1"
        width="1"
        style="border-style: none"
        alt=""
        src="https://insight.adsrvr.org/track/pxl/?adv=udguyav&ct=0:bzf5olo&fmt=3"
      />
    </div>
    <section :class="`pb-5 ${titleBackgroundColor}`">
      <div class="container pt-16 pb-8">
        <div class="flex">
          <!-- :src="require('@/assets/img/sketches/sun_two_clouds.png')" -->
          <div class="hidden lg:flex flex-col w-1/6 my-5 bg-no-repeat bg-contain">
            <img :src="require('@/assets/img/sketches/sun_two_clouds.png')" alt="" />
          </div>
          <div class="flex flex-col md:w-4/6 mx-auto">
            <h1 :class="`mt-4 lg:mt-16 text-center text-3xl md:text-5xl ${textColor} font-bold`">
              {{ feature.title }}
            </h1>
            <div v-if="category === 'shepherd'" class="hidden lg:flex justify-center">
              <img
                src="img/misc/shepherd_logo4C.png"
                alt="Shepherd Center"
                class="items-center w-1/2 py-1"
              />
            </div>
            <div :class="`text-center font-thin px-16 py-4 text-xl lg:text-2xl ${textColor}`">
              {{ feature.subtitle }}
            </div>
            <div class="flex justify-center my-2">
              <base-button
                class="rounded-lg px-8 py-4"
                @click="applyNow"
                aria-label="apply"
                type="primary text-xl md:text-3xl"
                id="apply-now-feature-button"
              >
                Check My Rate
              </base-button>
            </div>
          </div>
          <div
            class="hidden lg:flex flex-col w-1/6 bg-contain bg-right-bottom bg-no-repeat"
            style=""
          ></div>
        </div>
      </div>
    </section>
    <section class="pb-2 px-2">
      <h1 class="mt-16 lg:mt-12 mb-5 text-center text-3xl font-bold lg:text-5xl">
        The <span class="viva-blue-text">VIVA </span> Difference
      </h1>
      <div class="mx-auto xl:mx-48 2xl:mx-64">
        <div
          class="flex flex-wrap lg:flex-no-wrap lg:gap-10 mb-6 md:items-center md:justify-center"
        >
          <div v-if="feature.itemsList" class="flex-grow lg:flex-grow-0 landing-bullet-section">
            <div
              v-for="item in feature.itemsList.slice(0, 3)"
              :key="item"
              class="items-center landing-card-hover text-center hover:font-medium my-4 bg-white rounded-lg card-shadow dashboard-card text-xl md:text-xl text-black p-4"
            >
              {{ item }}
            </div>
          </div>
          <div v-if="feature.itemsList" class="flex-grow lg:flex-grow-0 landing-bullet-section">
            <div
              v-for="item in feature.itemsList.slice(3, 6)"
              :key="item"
              class="items-center dashboard-card-hover text-center hover:font-medium my-4 bg-white rounded-lg card-shadow dashboard-card text-xl md:text-xl text-black p-4"
            >
              {{ item }}
            </div>
          </div>
        </div>
      </div>
      <div
        class="flex items-center flex-wrap md:flex-no-wrap container justify-center md:gap-12 px-3 md:px-32 xl:px-64"
      >
        <img
          v-if="feature.highlightIcon"
          class="w-32"
          :src="require(`@/assets/img/icons/${feature.highlightIcon}-icon.svg`)"
          alt=""
        />
        <div class="text-2xl my-6" v-html="feature.highlightText"></div>
      </div>
    </section>
    <section class="section viva-blue section-lg pt-lg-0 px-2 mt-12 py-10">
      <h1 class="text-center text-4xl lg:text-5xl pt-3 text-white font-black">
        See what people are saying about VIVA
      </h1>
      <div class="container pt-3 pb-4">
        <div class="flex">
          <div class="col-lg-12">
            <div
              class="row flex flex-wrap md:flex-no-wrap px-2 md:px-2 gap-6 items-center justify-center"
            >
              <div class="col-lg-4">
                <div
                  class="card card-lift--hover dashboard-card dashboard-card-hover card-shadow border-0 text-center"
                >
                  <div class="card-body pt-2 lg:h-40">
                    <div class="flex flex-col items-center justify-center mb-2">
                      <p class="text-yellow-500 text-3xl">★★★★★</p>
                      <h3 class="h3">
                        “...They were professional, hassle-free, and produced really quick results.
                        I'd not only give them 5 stars, but they also get 2 thumbs up!”
                      </h3>
                    </div>
                    <p class="px-2 description mt-2">- Albert</p>
                  </div>
                </div>
              </div>
              <div class="col-lg-4">
                <div
                  class="card card-lift--hover dashboard-card dashboard-card-hover card-shadow border-0 text-center"
                >
                  <div class="card-body pt-2 lg:h-40">
                    <div class="flex flex-col items-center justify-center mb-2">
                      <p class="text-yellow-500 text-3xl">★★★★★</p>
                      <h3 class="h3">
                        “The best experience ever while receiving a loan. The process was easy and
                        quick... My money was really deposited the next day!”
                      </h3>
                    </div>
                    <p class="px-2 description mt-2">- Cherelle</p>
                  </div>
                </div>
              </div>
              <div class="col-lg-4">
                <div
                  class="card card-lift--hover dashboard-card dashboard-card-hover card-shadow border-0 text-center"
                >
                  <div class="card-body pt-2 lg:h-40">
                    <div class="flex flex-col items-center justify-center mb-2">
                      <p class="text-yellow-500 text-3xl">★★★★★</p>
                      <h3 class="h3">
                        “I am so glad that VIVA approved me for a loan! My mind is at ease now...
                        I'm in a much better place financially. Thank you VIVA!”
                      </h3>
                    </div>
                    <p class="px-2 description mt-2">- Rodney</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <div class="flex justify-center my-5">
      <base-button
        class="rounded px-6 py-4"
        @click="applyNow"
        aria-label="apply"
        type="primary text-lg"
      >
        Get Started Today
      </base-button>
    </div>

    <h1 class="mt-4 text-center text-2xl lg:text-3xl viva-blue-text font-bold italic my-5">
      Be Financially Empowered
    </h1>
  </body>
</template>

<script>
import marketingEmployers from '@/assets/marketingEmployers.json'
import featureLandingConfig from '@/assets/featureLandingConfig.json'
export default {
  name: 'landing-page',
  data() {
    return {
      marketingEmployers,
      feature: {}
    }
  },
  methods: {
    applyNow() {
      let q = this.$route.query
      if (this.$store.getters.authenticated) {
        this.$router.push({ name: 'Apply', query: q })
      } else {
        this.$store.commit('applicationData/setApplyNowRoute', window.location.href)
        this.$router.push({ path: '/register', query: q })
      }
    },
    scrollToBottom() {
      window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' })
    }
  },
  mounted() {
    let featureParam = this.$route.params.feature
    console.log('featureParam: ', featureParam)
    // In case we have a faulty URL or a redirect that can't be read
    // fall back to a feature we know exisits
    if (
      ![
        'credit-card-refinancing',
        'home-improvements',
        'legal-expenses',
        'medical-expenses',
        'debt-consolidation',
        'emergency-expense',
        'insurance-deductible',
        'large-purchase',
        'pay-bills',
        'auto-repair',
        'credit-builder',
        'travel-expenses',
        'credit-repair'
      ].includes(featureParam)
    ) {
      console.log('faileddddd: ')
      featureParam = 'credit-card-refinancing'
    }
    this.feature = featureLandingConfig[featureParam]
    let googleAnalyticsScript = document.createElement('script')
    googleAnalyticsScript.setAttribute('type', 'application/ld+json')
    googleAnalyticsScript.innerHTML =
      '{"@context":"https://schema.org/","@type":"Product","name":"' +
      this.feature.title +
      '","description":"' +
      this.feature.subtitle +
      '","brand":{"@type":"Brand","name":"VIVA Finance"},"aggregateRating":{"@type":"AggregateRating","ratingValue":"5.0","bestRating":"5.0","ratingCount":"601"}}'
    document.head.appendChild(googleAnalyticsScript)
  },
  computed: {
    getFeatureIcon() {
      let featureParam = this.$route.params.feature
      // In case we have a faulty URL or a redirect that can't be read
      // fall back to a feature we know exisits
      if (
        ![
          'credit-card-refinancing',
          'home-improvements',
          'legal-expenses',
          'medical-expenses',
          'debt-consolidation',
          'emergency-expense',
          'insurance-deductible',
          'large-purchase',
          'pay-bills',
          'auto-repair',
          'credit-builder',
          'travel-expenses',
          'credit-repair'
        ].includes(featureParam)
      ) {
        featureParam = 'credit-card-refinancing'
      }
      // let featureName = this.$route.params.feature
      let iconPath = '@/assets/img/icons/' + featureParam + '-icon.svg'
      return require(iconPath)
    },
    approvedEmployers() {
      return Object.keys(this.marketingEmployers['titleMapping'])
    },
    category() {
      if (this.$route.query && this.$route.query.employer) {
        const routeEmployer = this.$route.query.employer
        const lcEmployer = routeEmployer ? routeEmployer.toLowerCase() : ''
        console.log('Employer', lcEmployer)
        return this.approvedEmployers.includes(lcEmployer) ? lcEmployer : 'default'
      } else {
        let strippedPath = this.$route.path.replace('/', '').replace('employer-', '').toLowerCase()
        console.log(strippedPath)
        return this.approvedEmployers.includes(strippedPath) ? strippedPath : 'default'
      }
    },
    loadGimbal() {
      return this.category === 'healthcare'
    },
    textColor() {
      if (this.category === 'shepherd') {
        return 'text-shepherd-blue-100'
      }
      return 'text-white'
    },
    titleBackgroundColor() {
      if (this.category === 'shepherd') {
        return 'bg-white'
      }
      return 'viva-blue'
    },
    title() {
      return this.marketingEmployers.titleMapping[this.category]
    }
  }
}
</script>

<style lang="less">
.header-letter {
  width: 100%;
  max-width: 340px !important;
  font-weight: bold;
  color: white;
  text-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
  padding-bottom: 50px;
  font-size: 120px;
}
@media (min-width: 768px) {
  .header-letter {
    font-size: 260px;
  }
}
.header-body > div {
  height: 300px;
}
@media (min-width: 768px) {
  .header-body > div {
    height: 600px;
  }
}
.header-bg {
  background-blend-mode: multiply;
}
.titlemargin {
  margin-top: 10vh;
}
.screenfill {
  height: 100vh;
}
.left {
  width: 15%;
}

.middle {
  width: 60%;
}

.right {
  width: 15%;
}
</style>
